import {
  SET_BRANCH_TOTAL_RECORDS,
  SET_BRANCH_PAGE,
  EDIT_BRANCH,
  ADD_BRANCH,
  DELETE_BRANCH,
  BRANCH_LOADING,
  BRANCH_FAILURE,
  GET_BRANCH,
  SET_BRANCH_REDIRECT_URL,
  SET_ACIVE_BRANCH_PARTNER,
  RESET_BRANCH,
} from "./branch-constant";
import {
  handleLoading,
  handleFailure,
  handleSetRedirectUrl,
  handleGetData,
  handleSetTotalRecords,
  handleSetPage,
  handleEditItem,
  handleAddItem,
  handleDeleteItems,
} from "../utils/reducerUtils";

// Initial state
const initialState = {
  branchList: {},
  totalRecords: 0,
  totalPages: 0,
  currentPage: 1,
  loading: false,
  error: null,
  redirectTo: false,
  activePartnerID: "",
};

export const branchReducer = (state = initialState, action) => {
  switch (action.type) {
    case BRANCH_LOADING:
      return handleLoading(state, action);

    case BRANCH_FAILURE:
      return handleFailure(state, action);

    case SET_BRANCH_REDIRECT_URL:
      return handleSetRedirectUrl(state, action);

    case SET_ACIVE_BRANCH_PARTNER:
      return { ...state, activePartnerID: action.payload.partnerID };

    case GET_BRANCH:
      return handleGetData(state, action, "branchList");

    case SET_BRANCH_TOTAL_RECORDS:
      return handleSetTotalRecords(state, action);

    case SET_BRANCH_PAGE:
      return handleSetPage(state, action);

    case EDIT_BRANCH:
      return handleEditItem(state, action, "branchList", "branchId");

    case ADD_BRANCH:
      return handleAddItem(state, action, "branchList", "branchId");

    case DELETE_BRANCH:
      return handleDeleteItems(state, action, "branchList", "branchId");

    case RESET_BRANCH:
      return { ...initialState, activePartnerID: action.partnerID};
    default:
      return state;
  }
};
